export default __webpack_public_path__ + "static/media/facebook-square-brands.b74f6f59.svg";